import Vue from 'vue'
import Router from 'vue-router'
import Add from '@/components/additem'
import Search from '@/components/Search'
import Live from '@/components/Live'
import UserManageMent from '@/components/UserManageMent'
import Update from '@/components/Update'
import Show from '@/components/Show'
import Memo from '@/components/Memo'
import File from '@/components/File'
import Login from '@/components/Login'
import HelloWorld from '@/components/HelloWorld'
import Inventory from '@/components/Inventory'
import Detail from '@/components/Detail'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Search',
      component: Search
    },
    {
      path: '/add',
      name: 'Add',
      component: Add
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/live',
      name: 'Live',
      component: Live
    },
    {
      path: '/user',
      name: 'UserManageMent',
      component: UserManageMent
    },
    {
      path: '/update',
      name: 'Update',
      component: Update
    },
    {
      path: '/show',
      name: 'Show',
      component: Show
    },
    {
      path: '/memo',
      name: 'Memo',
      component: Memo
    },
    {
      path: '/file',
      name: 'File',
      component: File
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/inventory',
      name: 'Inventory',
      component: Inventory
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    }
  ]

})

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = localStorage.getItem('Authorization')
    if (token === 'null' || token === '' || token === 'undefined' || token === null || token === undefined) {
      next('/login')
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js